import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import Markdown from 'react-markdown'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Lottie from 'react-lottie'
import briefChart from '../lottie/brief_chart.json'
import { Box } from '@mui/material';
import ReleaseNotes from '../components/display/ReleaseNotes'
import ProjectContext from '../contexts/ProjectContext';
import {useFetch} from '../components/auth/useFetch';

export default function AboutView(props) {
    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);
    const [changeLogs, setChangeLogs] = useState(null)
    const [latestChangeLog, setLatestChangeLog] = useState(null)
    const fetchWithAuth = useFetch()

    const { makeTour, setIsLoading } = props
    const darktheme = createTheme({
        palette: {
            mode:'dark'
        }
    })

    const chart = {
        loop: false,
        autoplay: true,
        animationData: briefChart,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };

    useEffect(() => {
        isAuthenticated && (() => {
            getChangeLogs()
            })()
        }, [isAuthenticated])

    useEffect(() => {
        makeTour([
            {
                target: '#appbar-konsol-logo',
                page: 'About',
                title: 'Welcome to Konsol!',
                content: 'Click the Konsol logo to return to the home screen. When white in color, your data on the page has been loaded.',
                placement: 'bottom',
                locale: {
                    next: 'Next',
                },
            },
            {
                target: '#appbar-konsol-logo',
                page: 'About',
                title: 'Learning Konsol',
                content: 'When green in color, the page is loading your data.',
                placement: 'bottom'
            },
            {
                target: '#appbar-sidebar-button',
                page: 'About',
                title: 'Learning Konsol',
                content: 'The Sidebar can be opened/closed by clicking this icon.',
                placement: 'bottom'
            },
            {
                target: '#appbar-sidebar-button',
                page: 'About',
                title: 'Learning Konsol',
                content: 'The small lock icon indicates whether the Sidebar is pinned open or closed when navigating between pages. This can be configured in the user settings.',
                placement: 'bottom'
            },
            {
                target: '#sidebar-title-block',
                page: 'About',
                title: 'Title Block',
                content: 'The Title Block is a quick indicator of the production you are connected to. Click here to also switch the production you are working on.',
                placement: 'top',
                placementBeacon: 'top'
            },
            {
                target: '#appbar-transferdate-select',
                page: 'About',
                title: 'Dailies Transfer Date',
                content: 'The Dailies Transfer Date that you are working with can be selected from here. Simply click the dropdown to select your Transfer Date for the Dailies pages (Upload, Linking, Exports). By default the latest transfer date will appear first. ',
                placement: 'bottom',
            },
            {
                target: '#appbar-production-image',
                page: 'About',
                title: 'Your Production',
                content: 'The Production image can also be seen here.',
                placement: 'bottom',
            },
            {
                target: '#appbar-account-icon',
                page: 'About',
                title: 'Account Information',
                content: 'Click here for everything related to your account as well as additional account information.',
                placement: 'bottom',
            },
            {
                target: '#sidebar-navigation-items',
                page: 'About',
                title: 'Navigation',
                content: 'Finally to switch between pages click the categories to open up the page list.',
                placement: 'right',
                placementBeacon: 'right',
                locale: {
                    next: 'Finish',
                }
            },   
        ])
    }, [])

    const getChangeLogs = async () => {
        setIsLoading(true)
        await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/releasenotes/`, {
            method: "GET",
            headers: { 
                "Content-type": "application/json; charset=UTF-8",
                'X-Project-ID': projectContext?.project_db
            }
        })
        .then(res => {
            if(!res.ok) throw new Error(res.statusText)
            return res.json()
        })
        .then(res => {
            setLatestChangeLog(res[0])
            res.shift()
            setChangeLogs(res)
        })
        .catch(e => console.error(e))
        .finally(() => setIsLoading(false))
    }

    return (
        <ThemeProvider theme={darktheme}>
        <React.Fragment>
            <Box
                display='flex' 
                flexDirection={'column'}
                justifyContent={'center'}
                height='100%'
                bgcolor='rgba(0,0,0,0.7)'
            >
                <Box
                    margin = '40px 40px auto 40px'
                    justifyContent={'left'}
                    width={'90%'}
                    maxWidth={"1000px"}
                    height={'20%'}
                    maxHeight={'20%'}
                >
                    <h1>Release Notes</h1>

                    <h2>Latest Version</h2>
                    {
                    latestChangeLog
                    ?
                    <ReleaseNotes changelog={latestChangeLog} latest={true}/>
                    :
                    null
                    }

                    <br></br><br></br>
                    <h3>Previous Versions</h3>

                    {
                        changeLogs
                        ?
                        changeLogs.map(item => (
                        <ReleaseNotes changelog={item}/>
                        ))
                        :
                        <></>
                    }   

                </Box>
            </Box>
        </React.Fragment>
        </ThemeProvider>
    )
}